const localEnvironment = {
  baseUrl: 'https://test.www.sblcentral.org/API',
  loginUrl: 'https://test.www.sblcentral.org/API',
  defaultNotificationEmail: 'harsha.hammika@soltech.net',
  sessionTimeoutInSeconds: 1000 * 60 * 60,
  forgotPasswordUrl: 'https://sbl.mpxstage.com/account/login.aspx?forgot=yes',
  joinSBLUrl: 'https://sblsociety.kinsta.cloud/membership/join-or-renew/'
};
const SBLQAEnvironment = {
  baseUrl: 'https://test.www.sblcentral.org/API',
  loginUrl: 'https://www.sblcentral.org/API',
  defaultNotificationEmail: 'coconnor@sbl-site.org',
  sessionTimeoutInSeconds: 1000 * 60 * 60,
  forgotPasswordUrl: 'https://sbl.mpxstage.com/account/login.aspx?forgot=yes',
  joinSBLUrl: 'https://sblsociety.kinsta.cloud/membership/join-or-renew/'
};
const SBLUATEnvironment = {
  baseUrl: 'https://uat.sblcentral.org/API',
  loginUrl: 'https://uat.sblcentral.org/API',
  sessionTimeoutInSeconds: 1000 * 60 * 60
}
const SBLStagingEnvironment = {
  baseUrl: 'https://staging.sblcentral.org/API',
  loginUrl: 'https://authenticate.sbl-site.org',
  sessionTimeoutInSeconds: 1000 * 60 * 60
}
const SBLProdrodEnvironment = {
  baseUrl: 'https://www.sblcentral.org/API',
  loginUrl: 'https://www.sblcentral.org/API',
  sessionTimeoutInSeconds: 1000 * 60 * 60 * 4,
  forgotPasswordUrl: 'https://members.sbl-site.org/account/login.aspx?forgot=yes',
  joinSBLUrl: 'https://www.sbl-site.org'
};

let environment;

if (process.env.REACT_APP_ENVIRONMENT === 'SBLQA') {
  environment = SBLQAEnvironment;
}
else if (process.env.REACT_APP_ENVIRONMENT === 'SBLUAT') {
  environment = SBLUATEnvironment;
}
else if (process.env.REACT_APP_ENVIRONMENT === 'SBLProd') {
  environment = SBLProdrodEnvironment;
}
else if (process.env.REACT_APP_ENVIRONMENT === 'SBLSTAGING') {
  environment = SBLStagingEnvironment
}
else {
  environment = localEnvironment;
}

export default {
  // add common environment values here
  ...environment
};